
import "@sparta.global.utilities/sparta-sticky-utility/dist/styles.css"
import "@sparta.global-tenants.modules/gt-unauth-main-module/dist/styles.css"
import "@sparta.global-tenants.modules/gt-footer-unauth-placeholder-module/dist/styles.css"


import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import syncTaggingUtility from "@sparta.global-vtim.utilities/sync-tagging-utility/dist/es6.js"
import ahVendorWrapperUtility from "@sparta.authglobal.utilities/ah-vendor-wrapper-utility/dist/es6.js"
import syncAlloyUtility from "@sparta.global-vtim.utilities/sync-alloy-utility/dist/es6.js"

import "@sparta.global.modules/semantic-markup-module/dist/es6.js"
import "@sparta.ml-home.modules/bootstrap-module/dist/es6.js"
import "@sparta.global-tenants.modules/gt-unauth-main-module/dist/es6.js"
import "@sparta.global-tenants.modules/gt-footer-unauth-placeholder-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.sales.modules/eyebrow-banner-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-es6" */ "@sparta.sales.modules/eyebrow-banner-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-styles" */ "@sparta.sales.modules/eyebrow-banner-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.ml-shared.modules/ml-landing-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-landing-module-es6" */ "@sparta.ml-shared.modules/ml-landing-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-landing-module-styles" */ "@sparta.ml-shared.modules/ml-landing-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.wealth-shared.modules/section-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/wealth-shared-section-module-es6" */ "@sparta.wealth-shared.modules/section-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/wealth-shared-section-module-styles" */ "@sparta.wealth-shared.modules/section-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales.modules/flip-cards-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-flip-cards-module-es6" */ "@sparta.sales.modules/flip-cards-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-flip-cards-module-styles" */ "@sparta.sales.modules/flip-cards-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales.modules/ml-lms-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-ml-lms-module-es6" */ "@sparta.sales.modules/ml-lms-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-ml-lms-module-styles" */ "@sparta.sales.modules/ml-lms-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.ml-shared.modules/cta-tiles-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-cta-tiles-module-es6" */ "@sparta.ml-shared.modules/cta-tiles-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-cta-tiles-module-styles" */ "@sparta.ml-shared.modules/cta-tiles-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.ml-shared.modules/ml-tab-tiles-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-tab-tiles-module-es6" */ "@sparta.ml-shared.modules/ml-tab-tiles-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-tab-tiles-module-styles" */ "@sparta.ml-shared.modules/ml-tab-tiles-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.ml-shared.modules/ml-section-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-section-module-es6" */ "@sparta.ml-shared.modules/ml-section-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-section-module-styles" */ "@sparta.ml-shared.modules/ml-section-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/login-secure-ah-omni-channel-auth-first-factor-module-es6" */ "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/login-secure-ah-omni-channel-auth-first-factor-module-styles" */ "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.gt-docs.modules/gt-demo-ondemand-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/gt-docs-gt-demo-ondemand-module-es6" */ "@sparta.gt-docs.modules/gt-demo-ondemand-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/gt-docs-gt-demo-ondemand-module-styles" */ "@sparta.gt-docs.modules/gt-demo-ondemand-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.ml-shared.modules/ml-power-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-power-footer-module-es6" */ "@sparta.ml-shared.modules/ml-power-footer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-power-footer-module-styles" */ "@sparta.ml-shared.modules/ml-power-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales.modules/tiles-content-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-tiles-content-module-es6" */ "@sparta.sales.modules/tiles-content-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-tiles-content-module-styles" */ "@sparta.sales.modules/tiles-content-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.one-cms-poc.modules/standard-masthead-content-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/one-cms-poc-standard-masthead-content-module-es6" */ "@sparta.one-cms-poc.modules/standard-masthead-content-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/one-cms-poc-standard-masthead-content-module-styles" */ "@sparta.one-cms-poc.modules/standard-masthead-content-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.one-cms-poc.modules/masthead-four-cards-content-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/one-cms-poc-masthead-four-cards-content-module-es6" */ "@sparta.one-cms-poc.modules/masthead-four-cards-content-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/one-cms-poc-masthead-four-cards-content-module-styles" */ "@sparta.one-cms-poc.modules/masthead-four-cards-content-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.ml-shared-onecms.modules/ml-masthead-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-onecms-ml-masthead-module-es6" */ "@sparta.ml-shared-onecms.modules/ml-masthead-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-onecms-ml-masthead-module-styles" */ "@sparta.ml-shared-onecms.modules/ml-masthead-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales-onecms.modules/feature-block-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-onecms-feature-block-module-es6" */ "@sparta.sales-onecms.modules/feature-block-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-onecms-feature-block-module-styles" */ "@sparta.sales-onecms.modules/feature-block-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.login.shared-components/ah-secure-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-secure-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-secure-signin-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-passkey-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-passkey-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-passkey-signin-shared-component/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
  jcrs: [
    {
      name: "site/ml-home-dap/module-specific/landing-section/en/landing-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-landing-section-en-landing-section.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-landing-section-en-landing-section-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/lms-section/en/lms-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-lms-section-en-lms-section.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-lms-section-en-lms-section-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/sponsorship-section/en/sponsorship-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-sponsorship-section-en-sponsorship-section.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-sponsorship-section-en-sponsorship-section-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/flip-cards-section/en/flip-cards.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-flip-cards-section-en-flip-cards.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-flip-cards-section-en-flip-cards-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/cta-tiles-section/en/cta-tiles.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-cta-tiles-section-en-cta-tiles.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-cta-tiles-section-en-cta-tiles-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/bootstrap-module/en/moduleList.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-bootstrap-module-en-moduleList.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-bootstrap-module-en-moduleList-en-T1789053584668.json" )}
    },
    {
      name: "site/ah-secure-login/module-specific/hybrid/client-site-config.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ah-secure-login-module-specific-hybrid-client-site-config.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ah-secure-login-module-specific-hybrid-client-site-config-en-T1789053584668.json" )}
    },
    {
      name: "site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/data-v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-v1.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-v1-en-T1789053584668.json" )}
    },
    {
      name: "site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/error-v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-v1.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-v1-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/power-footer-module/en/power-footer-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-power-footer-module-en-power-footer-section.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-power-footer-module-en-power-footer-section-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/tiles-content-section/en/tiles-content-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-tiles-content-section-en-tiles-content-section.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-tiles-content-section-en-tiles-content-section-en-T1789053584668.json" )}
    },
    {
      name: "site/ml-home-dap/module-specific/tab-tiles-content-section/en/tab-tiles-content-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-home-dap-module-specific-tab-tiles-content-section-en-tab-tiles-content-section.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-ml-home-dap-module-specific-tab-tiles-content-section-en-tab-tiles-content-section-en-T1789053584668.json" )}
    },
    {
      name: "site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/data.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-en-T1789053584668.json" )}
    },
    {
      name: "site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/error.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error.json" */ "file:///apps/wt/deploy/tmp/F7083895/build/sit2a/site/ml/ml-dap/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-en-T1789053584668.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
ahVendorWrapperUtility.init();
  console.log('after - execute boot functions')
})();
